import FeaturedSoftwareCoursesSubtitle from './FeaturedSoftwareCoursesSubtitle';
//@ts-expect-error Could not find declaration file for module
import useIsEnrolledInUserGuide from '../../../hooks/useIsEnrolledInUserGuide';
import SkeletonFeaturedSoftwareCoursesHeader from './SkeletonFeaturedSoftwareCoursesHeader';
import { useIsPaidAccount } from '../../../hooks/productsHooks';
import { PageSectionHeading } from '../../SectionHeading';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FeaturedSoftwareCoursesHeader = ({
  isLoadingData,
  selectedTab,
  viewAllLink
}) => {
  const [isEnrolled, isEnrolledRequesting] = useIsEnrolledInUserGuide();
  const [isPaidAccount, isPaidAccountRequesting] = useIsPaidAccount();
  const {
    isTablet
  } = useMediaQuery();
  const isLoading = isLoadingData || isEnrolledRequesting || isPaidAccountRequesting;
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "start",
    columnGap: "300",
    flexWrap: isTablet ? 'wrap' : 'nowrap',
    inlineSize: "100%",
    justifyContent: "space-between",
    children: [/*#__PURE__*/_jsx(PageSectionHeading, {
      subtitle: isLoading ? /*#__PURE__*/_jsx(SkeletonFeaturedSoftwareCoursesHeader, {}) : /*#__PURE__*/_jsx(FeaturedSoftwareCoursesSubtitle, {
        isEnrolledOrPaid: isEnrolled || isPaidAccount,
        selectedTab: selectedTab
      }),
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.featuredSoftwareCourses.genericTitle"
      })
    }), viewAllLink]
  });
};
export default FeaturedSoftwareCoursesHeader;